/**
 * Site copyright line from CRA env (see `.env.production` / `.env.development`).
 * @returns {string} Trimmed value or empty when unset.
 */
export function getAppCopyrightLine() {
    const v = process.env.REACT_APP_COPYRIGHT;
    return typeof v === "string" ? v.trim() : "";
}
